<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Form Absen Siswa'">
          <template v-slot:body>
            <!-- <div class="custom-btn-all d-flex">
                <div class="btn-left d-flex justify-content-center align-items-center">
                  <b-icon icon="pencil-square" font-scale="1.5" style="color: white;"></b-icon>
                </div>
              </div> -->

            <div class="content">
              <b-alert v-if="noData" variant="warning font-weight-bold d-flex justify-content-center" show>
                Data absensi tidak ada
              </b-alert>
              <div
                v-else
                v-for="(row, index) in data"
                :key="index"
                class="card-content d-flex"
                :class="arrayColor[getIndexColor(index)]"
              >
                <div
                  class="d-flex justify-content-center align-items-center ml-3"
                >
                  <img
                    class="image"
                    :src="row.portrait_path?`${$endpoint}uploads/student_portrait/${row.portrait_path}`:defaultimg"
                    width="55"
                    height="55"
                  />
                  <div
                    class="personal-data d-flex align-items-center flex-column"
                  >
                    <b class="name">{{ row.name }}</b>
                    <p class="prodi">{{ row.NIM }}</p>
                  </div>
                </div>
                <div class="radio-group ml-auto d-flex align-items-center">
                  <v-radio-group row>
                    <label class="mr-10">
                      <input
                        type="radio"
                        value="1"
                        v-model="valuesPresensi[index].presensi"
                      />
                      Hadir
                    </label>

                    <label class="mr-10">
                      <input
                        type="radio"
                        value="2"
                        v-model="valuesPresensi[index].presensi"
                      />
                      Sakit
                    </label>

                    <label class="mr-10">
                      <input
                        type="radio"
                        value="3"
                        v-model="valuesPresensi[index].presensi"
                      />
                      Izin
                    </label>

                    <label class="mr-10">
                      <input
                        type="radio"
                        value="4"
                        v-model="valuesPresensi[index].presensi"
                      />
                      Alpha
                    </label>
                  </v-radio-group>
                </div>
              </div>

              <div class="row" style="margin-top: 2%">
                <div class="col-lg-6"></div>
                <div
                  class="col-lg-6 d-flex justify-content-end"
                  style="display: flex"
                >
                  <b-button
                    type="submit"
                    variant="outline-primary"
                    @click="onSubmit()"
                    style="margin-left: auto"
                    v-if="data.length > 0"
                    >Simpan</b-button
                  >
                  <b-button
                    type="reset"
                    variant="outline-danger"
                    class="ml-2"
                    style="margin-left: auto"
                    @click="$router.go(-1)"
                    >Batal</b-button
                  >
                </div>
              </div>
            </div>

            <b-modal id="modal" modal-class="modal-flex" hide-footer>
              <qrcode
                id="qrAbsensi"
                class="qrAbsensi"
                :options="{ width: 350, height: 350 }"
              ></qrcode>
              <p class="qr-text">
                Pindai Kode Untuk Konfirmasi Kehadiran Anda!
              </p>
            </b-modal>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";

export default {
  data() {
    return {
      // {name: 'Richard Sastya', NIM: '23019256473', status_kehadiran: 1, pertemuan_ke: 1}
      data: [],
      arrayColor: ["custom-grey", "custom-white"],
      selectedProdi: null,
      selectedJadwal: null,
      selectedPertemuan: null,
      valuesPresensi: [],
      prodiOptions: [{ id: null, text: "--Pilih Prodi--" }],
      jadwalOptions: [{ id: null, text: "--Pilih Jadwal--" }],
      pertemuanOptions: [{ id: null, text: "--Pilih Pertemuan--" }],
      search: "",
      noData: false,
    };
  },
  components: {
    KTCodePreview,
  },
  computed: {
    key_prodi() {
      return this.$route.params != null
        ? this.$route.params.props.key_prodi
          ? this.$route.params.props.key_prodi
          : this.$route.params.props.id_prodi
        : null;
    },
    key() {
      return this.$route.params != null ? this.$route.params.props.key : null;
    },
    pertemuan_ke() {
      return this.$route.params != null
        ? this.$route.params.props.pertemuan_ke
        : null;
    },
    defaultimg(){
      return process.env.BASE_URL+'media/users/default.png'
    },
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Rekap" },
      { title: "Absen Siswa" },
    ]);
    this.getData();
  },
  methods: {
    getIndexColor(index) {
      if (index % 2 == 0) {
        return 0;
      } else {
        return 1;
      }
    },

    async getData() {
      try {
        let result = null;
        if (this.$route.params.props.id_prodi) {
          result = await axios.get(
            `master/jadwal/latek/absen/${this.key_prodi}/${this.key}`
          );
        } else {
          result = await axios.get(
            `master/attendance/${this.key_prodi}/${this.key}/${this.pertemuan_ke}`
          );
        }

        // Cek apakah data ada dan valid
        if (result.data && result.data.data && result.data.data[0] && result.data.data[0].length > 0) {
          this.data = result.data.data[0];
          for (let x = 0; x < result.data.data[0].length; x++) {
            let object = { presensi: this.data[x].status_kehadiran };
            this.valuesPresensi.push(object);
          }
        } else {
          this.noData = true;
        }
      } catch (error) {
        if (error.response) {
          const statusCode = error.response.status;
          if (statusCode === 401) {
            // Redirect to the login page for a 401 error
            this.$router.push("/login");
          } else if (statusCode === 500) {
            // Show an alert for a 500 error
            this.$swal("Terjadi Kesalahan");
          }
          // Handle other status codes as needed
        } else {
          // Handle other types of errors (e.g., network error)
          this.$swal("Terjadi Kesalahan");
        }
      }

      //
      //
      //
    },
    async onSubmit() {
      const d = new Date();
      let temp = {
        student_id: [],
        status_kehadiran: [],
        schedule_id: null,
        tanggal: null,
        pertemuan_ke: null,
      };
      this.data.map((v, index) => {
        temp.student_id.push(v.key_student),
          temp.status_kehadiran.push(this.valuesPresensi[index].presensi),
          (temp.course_id = this.key_prodi),
          (temp.lecturer_id = v.lecturer_id),
          (temp.schedule_id = this.key),
          (temp.pertemuan_ke = this.pertemuan_ke),
          // "status_kehadiran": v.status_kehadiran,
          (temp.tanggal = `${d.getFullYear()}-${
            d.getMonth() + 1
          }-${d.getDate()}`);
      });
      //let arraySend = this.data.map((v, index) => ({
      // ...v,
      // "student_id": v.student_key,
      //"course_id": this.selectedProdi,
      //"lecturer_id": v.lecturer_id,
      //"schedule_id": this.selectedJadwal,
      // "pertemuan_ke": this.selectedPertemuan,
      // "status_kehadiran": v.status_kehadiran,
      //"status_kehadiran": this.valuesPresensi[index].presensi,
      // "tanggal": `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
      //}))
      let result = null;
      if (this.$route.params.props.id_prodi) {
        result = await axios.post(
          `master/jadwal/latek/post-absensi-siswa`,
          temp
        );
      } else {
        result = await axios.post(`master/attendance/add`, temp);
      }
      if (result.data.meta.code != 200) {
        var statusStore = false;
        this.$swal("Gagal", "Presensi Gagal Disimpan!", "OK");
      }

      if (statusStore != false) {
        this.$swal({
            title: 'Berhasil',
            text: 'Presensi Berhasil Disimpan!',
            icon: 'success',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: `lecturer-schedule-absence`}).catch(() => {});
            }
          });
        // this.$swal("Berhasil", "Presensi Berhasil Disimpan!", "OK");
        // this.data = [];
        // this.getData();
      }

      //for (let key in arraySend) {
      //let result = await axios.post(`master/attendance/add`, JSON.parse(JSON.stringify(arraySend[key])))
      //if (result.data.meta.code != 200) {
      // var statusStore = false
      //this.$swal('Gagal', 'Presensi Gagal Disimpan!', 'OK')
      //break
      // }
      //}

      //if (statusStore != false) {
      //  this.$swal('Berhasil', 'Presensi Berhasil Disimpan!', 'OK')
      //  this.data = []
      //  this.getData()
      //}

      //
    },
  },
};
</script>
<style lang="scss">
.modal-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-btn-all {
  width: 120px;
  height: 48px;
  background: #3751e4;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  margin-bottom: 30px;
}

.custom-btn-all > .btn-left {
  width: 120px;
  height: 100%;
  cursor: pointer;
}

.custom-btn-all > .btn-right {
  width: 120px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  cursor: pointer;
}

.card-content {
  // background-color: #D9D9D9;
  width: 100%;
  height: 70px;
  border-radius: 10px;
}

.profile .image {
  border-radius: 50px;
}

.card-content {
  margin-top: 20px;
}

.personal-data {
  margin-left: 20px;
}

.personal-data > .name {
  font-size: 15px;
  line-height: 19px;
  color: black;
}

.personal-data > .prodi {
  margin-bottom: 0;
  margin-top: 5px;
  font-size: 12px;
  line-height: 15px;
}

.custom > label {
  margin-bottom: 0;
}

.qr-text {
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  text-align: center;

  color: #485377;
}

.custom-grey {
  background-color: #d9d9d9;
}

.custom-white {
  background-color: #f1f0f0;
}

.v-label {
  margin-bottom: 0 !important;
}
</style>
